import {Component, Input} from '@angular/core';
import {ArrowDirection} from '../../../modules/health-score-guage/ArrowDirection';

@Component({
  selector: 'app-updown-arrow',
  templateUrl: './updown-arrow.component.html',
})
export class UpdownArrowComponent {
  @Input() direction: string | ArrowDirection;

}
